/**
 * @generated SignedSource<<76761ce4f3b4153ed11ea4e27a8abc6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useImproveSalePriceDisplayAbTest_displayPrice$data = {
  readonly amountType: string | null;
  readonly " $fragmentType": "useImproveSalePriceDisplayAbTest_displayPrice";
};
export type useImproveSalePriceDisplayAbTest_displayPrice$key = {
  readonly " $data"?: useImproveSalePriceDisplayAbTest_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"useImproveSalePriceDisplayAbTest_displayPrice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useImproveSalePriceDisplayAbTest_displayPrice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "12823933e3401dc5bdb290c29c3a21b1";

export default node;
